import React, { useState, useEffect } from 'react';
import { useEasybase } from 'easybase-react';
import { Button, Card, CardContent, CardActions, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KartenStyle } from './KartenStyle';
import { normalesDatum, jetzt, folgeTag } from './ZeitFunktionen';
import SchablonenEditDialog from './SchablonenEditDialog';

const Schablonen = (props) => {
    const useStyles = makeStyles(KartenStyle);
    const classes = useStyles();

    const { db, e } = useEasybase();
    const [schablonen, setSchablonen] = useState([]);
    const schabloneTable = db("SCHABLONE");
    const kursTable = db("KURS");
    const buchTable = db("BUCHUNG");

    const mounted = async () => {
        console.log("await " + props.sr);
        await schabloneTable.return()
            .where(e.eq('sr', props.sr))
            .limit(50).all().then(ebData => {
                setSchablonen(ebData);
                console.log("Data:" + ebData);
            });
    };

    useEffect(() => {
        mounted();
        // eslint-disable-next-line
    }, []);

    const [editOpen, setEditOpen] = useState(false);
    const [neuYyyyMmDd, setNeuYyyyMmDd] = useState('');
    const [neuHhMm, setNeuHhMm] = useState('');
    const [neuAktiv, setNeuAktiv] = useState(false);
    const [neuName, setNeuName] = useState('');
    const [neuMax, setNeuMax] = useState(25);
    const [neuKey, setNeuKey] = useState('');
    const addNewSchablone = () => {
        const [yyyymmdd, hhmm] = jetzt();
        setNeuHhMm(hhmm);
        setNeuYyyyMmDd(yyyymmdd);
        setNeuMax(25);
        setNeuAktiv(false);
        setNeuName('');
        setNeuKey(null);
        setEditOpen(true);
    };

    const onEdit = (index) => {
        console.log("Index "+index);
        setNeuHhMm(schablonen[index].zeit);
        setNeuYyyyMmDd(schablonen[index].letztertermin);
        setNeuMax(schablonen[index].max);
        setNeuAktiv(schablonen[index].aktiv);
        setNeuName(schablonen[index].name);
        setNeuKey(schablonen[index]._key);
        setEditOpen(true);
    };

    const onSchabExit = (erg) => {
        setEditOpen(false);
        if (erg) {
            mounted();
        }
    }

    const onSetAktiv = async (event) => {
        console.log("SetAktiv:" + event.currentTarget.value);
        await schabloneTable.where({ _key: event.currentTarget.value }).set({ aktiv: true }).one();
        mounted();
    }

    const onResetAktiv = async (event) => {
        console.log("ResetAktiv:" + event.currentTarget.value);
        await schabloneTable.where({ _key: event.currentTarget.value }).set({ aktiv: false }).one();
        mounted();
    }

    const onRemove = async (event) => {
        console.log("onRemove:" + event.currentTarget.value);
        await schabloneTable.delete().where(e.eq('_key', event.currentTarget.value)).one();
        mounted();
    }

    const aktualisiereLetzterTermin = async (key, lt) => {
        console.log("Setzt letztertermin auf " + lt);
        await schabloneTable.where(
            e.and(
                e.lt('letztertermin', lt),
                e.eq('_key', "" + key)
            )
        ).set({ 'letztertermin': lt }).one().then(updRes => {
            console.log("Result update:" + updRes);
        });
    }

    const einfuegenKurs = async (kurse, lt, schab) => {
        console.log("Kurs wird angelegt " + lt + " Schablone:" + schab._key + " name:" + schab.name);
        await kursTable.insert({
            schabloneid: "" + schab._key,
            name: schab.name,
            zeit: schab.zeit,
            datum: lt,
            max: schab.max,
            bemerkung: "",
            aktiv: true,
            sr: props.sr
        }).one().then(insRes => {
            console.log("Result insert:" + insRes);
            aktualisiereLetzterTermin(schab._key, lt);
        });
    }

    const testeKurs = async (schab, lt) => {
        console.log("Kurs wird angefragt. Datum:" + lt + " Schablone:" + schab._key);
        await kursTable.return().where(
            e.and(
                e.eq('schabloneid', "" + schab._key),
                e.eq('datum', lt),
                e.eq('sr', props.sr)
            )
        ).limit(10).all().then(kurse => {
            console.log("Antwort auf Kurssuche:" + kurse.length + " für " + schab._key + " " + lt);
            if (kurse.length === 0) {
                einfuegenKurs(kurse, lt, schab);
            } else {
                console.log("Kurs " + schab._key + " " + lt + " schon da");
            }
        });
    }

    const rekLoeschenKurse = async (kurs) => {
        await kursTable.delete().where(e.eq('_key', kurs._key)).all();
    }

    const rekLoeschenBuchungen = async (kurs) => {
        await buchTable.delete().where(e.eq('kursid', kurs._key)).all();
    }

    const onAnlegen = async () => {
        console.log("Anlegen beginnt");
        const [yyyymmdd, hhmm] = jetzt();
        const ende = folgeTag(yyyymmdd, 14);
        console.log("Aktueller Tag:" + yyyymmdd + " Grenze:" + ende);
        const schabs = await schabloneTable.return().where(
            e.and(
                e.eq('aktiv', true),
                e.eq('sr', props.sr),
                e.lte('letztertermin', ende)
            )
        ).all();
        schabs.forEach(schab => {
            console.log("Key:" + schab._key + " Name:" + schab.name + " letzterTermin:" + schab.letztertermin + " Zeit:" + schab.zeit);
            let lt = schab.letztertermin;
            while (lt < yyyymmdd) {
                console.log("in der Vergangenheit, " + lt);
                lt = folgeTag(lt, 7);
            }
            if (lt === yyyymmdd && hhmm > schab.zeit) {
                console.log("heute, aber auch schon vorbei, " + lt + " " + hhmm);
                lt = folgeTag(lt, 7);
            }
            while (lt <= ende) {
                testeKurs(schab, lt);
                lt = folgeTag(lt, 7);
            }
        });
    }

    const onSaeubern = async () => {
        const [yyyymmdd, hhmm] = jetzt();
        console.log("Kurse zum Löschen angefragt: " + yyyymmdd + " " + hhmm);
        await kursTable.return("_key").where(
            e.or(
                e.lt('datum', yyyymmdd),
                e.and(
                    e.eq('datum', yyyymmdd),
                    e.lt('zeit', hhmm)
                )
            )
        ).limit(100).all().then(kurse => {
            console.log("Antwort auf Kurssuche:" + kurse.length);
            if (kurse.length > 0) {
                kurse.forEach((kurs) => {
                    console.log("Kurs säubern :" + kurs._key);
                    rekLoeschenKurse(kurs);
                    rekLoeschenBuchungen(kurs);
                });
            }
        });
    }

    return (
        <Grid style={{ padding: 16 }} container spacing={3}>
            <Grid item xs={12}>
                <Typography variant="h4">{props.sr === 'r' ? "REHA" : "Sportarena"}-Schablonen:</Typography>
            </Grid>
            {schablonen.map((schab, index) => <Grid item xs={3}>
                <Card key={schab._key} className={classes.root}>
                    <CardContent>
                        <Typography key={schab.key + ".n"} variant="body1">{schab.name}</Typography>
                        <Typography key={schab.key + ".l"} variant="body1">letzter Aushang: {normalesDatum(schab.letztertermin)} {schab.zeit}</Typography>
                        <Typography key={schab.key + ".t"} variant="body1">TN: {schab.max} {schab.aktiv ? "AKTIV" : "---"}</Typography>
                    </CardContent>
                    <CardActions>
                        <Button value={schab._key} variant="contained" onClick={schab.aktiv ? onResetAktiv : onSetAktiv}>{schab.aktiv ? "Dea" : "A"}ktivieren</Button>
                        <Button value={schab._key} variant="contained" onClick={onRemove}>L&ouml;schen</Button>
                        <Button value={index} variant="contained" onClick={(event) => onEdit(event.currentTarget.value)}>Bearbeiten</Button>
                    </CardActions>
                </Card></Grid>
            )}
            <Grid item xs={3}>
                <Button value="neueSchablone" variant="contained" onClick={() => addNewSchablone()}>+ Neue Schablone</Button>
            </Grid>
            {editOpen && <SchablonenEditDialog
                edKey={neuKey}
                edLetzterTermin={neuYyyyMmDd}
                edZeit={neuHhMm}
                edMax={neuMax}
                edAktiv={neuAktiv}
                edName={neuName}
                sr={props.sr}
                fertig={onSchabExit} />}
            <Grid item xs={12}>
                <Button value="Anlegen" variant="contained" onClick={onAnlegen}>f&auml;llige Kurse anlegen</Button>
                <Button value="Saeubern" variant="contained" onClick={onSaeubern}>alte Kurse entfernen</Button>
            </Grid>
        </Grid>
    );
};
export default Schablonen;

